import { ACCOUNTS_DATA } from "../../Types/Accounts";

export const SET_ACCOUNTS_DATA = (payload) => ({
    type: ACCOUNTS_DATA,
    payload
  })